import { ResultInfoResponseBuilder } from './ResultInfoResponseBuilder';
import { MatrixResponseBuilder } from './MatrixResponseBuilder';
import { ActivityWithContentResponseBuilder } from './ActivityWithContentResponseBuilder';
import { PointOfInterestResponseBuilder } from './PointOfInterestResponseBuilder';
import { IBaseArgument } from './IBaseArgument';
import { BaseResponseBuilder } from './BaseResponseBuilder';

export class SearchActivityResultResponseBuilder extends BaseResponseBuilder {
    constructor() {
        super('SearchActivityResult');
    }
    public withIsCompleted = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['isCompleted'] = this.initField(null, args);
        return this;
    }

    public withResultInfo = (builder: ResultInfoResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['resultInfo'] = this.initField(builder, args);
        return this;
    }

    public withMatrix = (builder: MatrixResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['matrix'] = this.initField(builder, args);
        return this;
    }

    public withActivities = (builder: ActivityWithContentResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['activities'] = this.initField(builder, args);
        return this;
    }

    public withPointOfInterests = (builder: PointOfInterestResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['pointOfInterests'] = this.initField(builder, args);
        return this;
    }
}
